import { Handle, Position } from '@xyflow/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './NodeStyles.css';

function CharacterNode({ data, isConnectable }) {
    const { t } = useTranslation();
    const [isEditing, setIsEditing] = useState(false);
    const [label, setLabel] = useState(data.label);
    const [description, setDescription] = useState(data.description || '');

    const handleLabelChange = (e) => {
        setLabel(e.target.value);
        data.label = e.target.value;
    };

    const handleDescChange = (e) => {
        setDescription(e.target.value);
        data.description = e.target.value;
    };

    return (
        <div className="canvas-node character-node" onDoubleClick={() => setIsEditing(true)}>
            <Handle type="target" position={Position.Top} isConnectable={isConnectable} />

            <div className="node-header">
                <span className="node-icon">👤</span>
                {isEditing ? (
                    <input
                        type="text"
                        className="node-input"
                        value={label}
                        onChange={handleLabelChange}
                        onBlur={() => setIsEditing(false)}
                        autoFocus
                    />
                ) : (
                    <span className="node-title">{label}</span>
                )}
            </div>

            {isEditing ? (
                <textarea
                    className="node-textarea"
                    value={description}
                    onChange={handleDescChange}
                    placeholder={t('editor.canvas.characterDetails')}
                    rows={3}
                />
            ) : description ? (
                <p className="node-description">{description}</p>
            ) : null}

            <Handle type="source" position={Position.Bottom} isConnectable={isConnectable} />
        </div>
    );
}

export default CharacterNode;
